export default "__VITE_ASSET__41afc537__"